import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css'; // Import theme CSS


export default function DatePicker({ value, minDate, changeFunction }) {
    const handleDateChange = ([selectedDate]) => {
        // Convert to MySQL format (YYYY-MM-DD)
        const mysqlDate = `${selectedDate.getFullYear()}-${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedDate.getDate().toString().padStart(2, '0')}`;
        changeFunction(mysqlDate);
    };
    
    return (
        <Flatpickr className="border p-2 rounded w-[200px]"
            value={value}
            onChange={(date) => handleDateChange(date)}
            options={{
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'F j, Y', // Display format: "January 1, 2024"
                ...(minDate && { minDate })
            }}
        />
    );
};
